
import { Mixins } from '@vedicium/metronic-vue';
import Vue from 'vue';
import { BModal } from 'bootstrap-vue';
import { required } from 'vuelidate/lib/validators';
import { SunbedModelShippingBox } from '../../../../../services/sunbeds';
import {
  CONFIGURATIONS_SHIPPING_BOX_MODAL_OPEN,
  CONFIGURATIONS_SHIPPING_BOX_MODAL_CLOSE,
} from './shipping-box-modal.constants';
import { ConfigurationShippingBoxModalOptions } from './interfaces';
import { ValidatorUtil } from '@vedicium/vue-core';

export default Vue.extend({
  name: 'configurationsShippingBoxModal',
  mixins: [Mixins.Modal],
  components: {},
  data() {
    return {
      options: undefined as ConfigurationShippingBoxModalOptions | undefined,

      document: undefined as SunbedModelShippingBox | undefined,

      isLoadingForm: false,
    };
  },
  validations: {
    document: {
      content: {
        required,
      },
    },
  },

  mounted(): void {
    this.$eventhub.on(CONFIGURATIONS_SHIPPING_BOX_MODAL_OPEN, this.open);
    this.$eventhub.on(CONFIGURATIONS_SHIPPING_BOX_MODAL_CLOSE, this.close);
  },
  beforeDestroy(): void {
    this.$eventhub.off(CONFIGURATIONS_SHIPPING_BOX_MODAL_OPEN, this.open);
    this.$eventhub.off(CONFIGURATIONS_SHIPPING_BOX_MODAL_CLOSE, this.close);
  },

  methods: {
    async validate(): Promise<void> {
      await ValidatorUtil.validateArray([this.$v]);
    },
    async onSubmit(): Promise<void> {
      this.$set(this, 'isLoadingForm', true);
      try {
        await this.validate();

        if (typeof this.options?.onSubmit === 'function') {
          await this.options.onSubmit(this.document as SunbedModelShippingBox);
        }
      } catch (e) {
        console.error(e);
        this.options?.onError?.(e as Error);
        return;
      } finally {
        this.$set(this, 'isLoadingForm', false);
      }

      this.close();
    },

    async open(options?: ConfigurationShippingBoxModalOptions): Promise<void> {
      this.$set(this, 'options', options || undefined);
      this.$set(this, 'document', options?.entity || undefined);

      await this.$nextTick();
      this.$v.$reset();

      (this.$refs.modal as BModal).show();
    },
    close(): void {
      (this.$refs.modal as BModal).hide();
    },

    async onShown(): Promise<void> {
      await this.$nextTick();

      (this.$refs['input:content'] as HTMLInputElement).focus();
    },
  },
});
